import "./updateTicketLocalTime.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import newRequest from "../../../context/newRequest";
import {formatDate, sleep} from "../../../helper/helper";

const UpdateTicketLocalTime = ({ title }) => {
    const [ticketInfo, setticketInfo] = useState({});
    const [sending, setSending] = useState("");
    const { ticketId } = useParams();
    const user = localStorage.getItem("user");
    const { data, loading, error } = useFetch(`/ticketsite/${ticketId}`);
    const navigate = useNavigate();
    const [upTime, setUpTime] = useState(""); // For storing user-selected Up Time
    const [downTime, setDownTime] = useState(""); //

    useEffect(() => {
        setticketInfo(data);
    }, [data]);



    const dateTicket = () => {
        const dateCreated =  formatDate(ticketInfo.created_at);
        const dateUpdate = formatDate(ticketInfo.updated_at);
        const downTime = formatDate(ticketInfo.down_time);
        const dateSubmit = formatDate(ticketInfo.date_submit);
        let UpTime;
        if (ticketInfo.up_time === 0) {
            UpTime = "Not Available";
        } else {
            UpTime = formatDate(ticketInfo.up_time);
        }
        const date = {
            create_at : dateCreated,
            updated_at: dateUpdate,
            down_time : downTime,
            up_time : UpTime,
            date_submit: dateSubmit,

        }
        return date;
    }
    const date = dateTicket()



    console.log(ticketInfo)

    const handleClick = async (e) => {
        e.preventDefault();
        setSending("On Submit")
        try {
            setSending("Mengirim Data")
            const upTimeMillis = new Date(upTime).getTime();
            const downTimeMillis = new Date(downTime).getTime();

            const newTicketUpdate = {
                up_time: upTimeMillis,
                down_time: downTimeMillis,
            };

            const res= await newRequest.put(`/ticketsite/time/${ticketId}`, newTicketUpdate, {
                // headers
                headers: {
                    'Authorization': `$Bearer ${user.token}`
                },
            });
            if (res.status == 200) {
                await sleep(2000)
                setSending("Berhasil Mengirim Data")
                navigate(`/ticketsite/${ticketId}`);
            }
            console.log(res.status)
        } catch (err) {
            setSending(err.response.data.errors)
            console.log(err);
        }
    };
    return (
        <div className="new">
            <Sidebar />
            <div className="newContainer">
                <Navbar/>
                <div className="top">
                    <h1>{title}</h1>
                </div>
                <div className="bottom">
                    <div className="right">
                        <div className="detailItem">
                            <span className="itemKey">Ticket ID:</span>
                            <span className="itemValue">{ticketId}</span>
                        </div>
                        <div className="detailItem">
                            <span className="itemKey">Site Customer:</span>
                            <span className="itemValue">
                        {ticketInfo.customer_site}
                  </span>
                        </div>

                        <div className="detailItem">
                            <span className="itemKey">Down Time:</span>
                            <span className="itemValue">{date.down_time}</span>
                        </div>

                        <div className="detailItem">
                            <span className="itemKey">Up Time:</span>
                            <span className="itemValue">{date.up_time}</span>
                        </div>

                        <form>
                            <div className="formInput">

                                <label>Down Time:</label>
                                <input
                                    type="datetime-local"
                                    onChange={(e) => setDownTime(e.target.value)}
                                />
                                <br/>
                                <br/>
                                <br/>
                                <label>Up Time:</label>
                                <input
                                    type="datetime-local"
                                    onChange={(e) => setUpTime(e.target.value)}
                                />


                                <button onClick={handleClick}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
                {sending && <p className="error">{sending}</p>}
                <br/>
                <br/>
                <br/>
                <br/>

            </div>
        </div>
    );
};

export default UpdateTicketLocalTime;